import type { ProviderCredentialSummary } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteProviderCredentialDialogProps {
  credential: ProviderCredentialSummary | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteProviderCredentialDialog({
  credential,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteProviderCredentialDialogProps) {
  return (
    <Modal open={credential !== null} title="Remove provider credential" onClose={onCancel}>
      <p>
        Remove <strong>{credential?.label}</strong>? Comebye can no longer manage instances that depend on it once
        it's gone — you'll be told if any still do. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Removing…" : "Remove"}
        </Button>
      </div>
    </Modal>
  );
}
